import React from "react";
import { Form, Input } from "antd";
import { BankOutlined } from "@ant-design/icons";

const BankNumber = (props) => {
  // -------------------------- VAR --------------------------
  const { disabled } = props;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="bankNumber"
      label="Bank Number"
      rules={[
        {
          required: true,
          message: "Please input Bank Number",
        },
        {
          whitespace: true,
          message: "Please input Bank Number",
        },
      ]}
    >
      <Input
        type="number"
        prefix={<BankOutlined className="form-item-icon" />}
        placeholder="Bank Number"
        disabled={disabled}
      />
    </Form.Item>
  );
};

export default BankNumber;
